import { Routes } from '@angular/router';
import { authGuard } from 'src/app/guard/auth.guard';
import { companyGuard } from '../guard/company.guard';
import { companyUsersGuard } from '../guard/company-users.guard';
import { CompanyLayoutComponent } from '../layouts/company-layout/company-layout.component';
import { UserComponent } from '../pages/admin/company/user/user.component';
import { CompanyDetailComponent } from '../pages/company/company-detail/company-detail.component';
import { ProcessDetailComponent } from '../pages/process/process-detail/process-detail.component';
import { ProcessComponent } from '../pages/process/process.component';
import { UserProfileComponent } from '../pages/user-profile/user-profile.component';
import { EulaComponent } from '../pages/eula/eula.component';
import { InformationComponent } from '../pages/admin/information/information.component';
import { InformationDetailComponent } from '../pages/admin/information/information-detail/information-detail.component';

export const MainLayoutRoutes: Routes = [
  {
    path: '',
    redirectTo: 'pef-database',
    pathMatch: 'full'
  },
  {
    path: 'profile',
    data: { title: 'Profile' },
    component: UserProfileComponent
  },
  {
    path: 'company',
    data: { title: "company" },
    children: [
      {
        path: ':companyId',
        data: { title: null },
        component: CompanyLayoutComponent,
        canActivate: [companyGuard],
        children: [
          {
            path: '',
            component: CompanyDetailComponent,
            data: { title: "information" }
          },
          {
            path: 'users',
            component: UserComponent,
            canActivate: [companyUsersGuard],
            data: { title: "users" }
          }
        ]
      }
    ]
  },
  {
    path: 'pef-database',
    canActivate: [authGuard],
    data: { title: 'pef database' },
    children: [
      {
        path: '',
        component: ProcessComponent,
        data: { title: null }
      },
      {
        path: ':processId',
        component: ProcessDetailComponent,
        data: { title: 'information' }
      }
    ]
  },
  // keep old "process" links working after the rename to "pef-database"
  {
    path: 'process',
    redirectTo: 'pef-database',
    pathMatch: 'full'
  },
  {
    path: 'process/:processId',
    redirectTo: 'pef-database/:processId'
  },
  {
    path: 'eula',
    canActivate: [authGuard],
    data: { title: 'eula' },
    children: [
      {
        path: '',
        component: EulaComponent,
        data: { title: null }
      }
    ]
  },
  {
    path: 'information',
    data: { title: 'information' },
    children: [
      {
        path: '',
        component: InformationComponent,
        data: { title: null }
      },
      {
        path: 'detail/:informationId',
        component: InformationDetailComponent,
        data: { title: 'detail', breadcrumbParam: 'informationId' }
      }
    ]
  }
];
